import { createContext } from 'react';

export const authContext = createContext({});

export const AuthProvider = authContext.Provider;
export const AuthConsumer = authContext.Consumer;

export default authContext;
